import { InventoryReceiptQcResult } from 'types/inventoryEnums.interface'

export const receiptsOptions = [
  { value: 1, label: 'Draft' },
  { value: 2, label: 'Posted' },
  { value: 3, label: 'Canceled' },
]

export const receiptQcResultOptions = [
  { value: InventoryReceiptQcResult.Pass, label: 'Pass' },
  { value: InventoryReceiptQcResult.Pending, label: 'Pending' },
  { value: InventoryReceiptQcResult.Rejected, label: 'Rejected' },
]
